import dynamic from 'next/dynamic';

const Container = dynamic(
  () => import('@uikit/components/Container/Container')
);
const Headline = dynamic(() => import('@uikit/components/Headline/Headline'));
const ImageGallery = dynamic(
  () => import('@uikit/components/ImageGallery/ImageGallery')
);
const PressImageWrapper = dynamic(
  () => import('@uikit/components/Press/PressImage/PressImageWrapper')
);
const TwoColumnContainer = dynamic(
  () => import('@uikit/components/TwoColumnContainer/TwoColumnContainer')
);
const PressArticleRichText = dynamic(
  () => import('@uikit/composites/PressArticleRichText/PressArticleRichText')
);

export const CmsComponentsPress = {
  'press-image-gallery': ImageGallery,
  'press-article-headline': Headline,
  'press-article-rich-text': PressArticleRichText,
  'press-image': PressImageWrapper,
  'press-additional-content-container': Container,
  'press-additional-content-two-column-container': TwoColumnContainer,
};
